function MiniText(text) {
  this.name='minitext';
  this.text=text;
}

export {MiniText};
